import { FormlyModule } from '@ngx-formly/core';

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslationModule } from '@lib/translation';
import { SnIconModule } from '@lib/ui/icon';

import { SnFormFieldGroupFormWrapper } from './components/form-field-group-wrapper/form-field-group.wrapper';

@NgModule({
  imports: [
    // Angular
    CommonModule,
    // Formly
    FormlyModule.forChild({
      wrappers: [
        {
          name: 'form-field-group',
          component: SnFormFieldGroupFormWrapper,
        },
      ],
    }),
    // Libs
    SnIconModule,
    // i18n
    TranslationModule,
  ],
  declarations: [SnFormFieldGroupFormWrapper],
})
export class SnFormFieldGroupModule {}
